import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class HighwaysService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  createHighway(formdata: any) {
    return this.http.post(`${this.baseUrl}/v1/highways`, { ...formdata })
  }
  getAll(
    pageIndex: number,
    sortDirection?: string,
    sortProperty?: string,
    name?: string
  ) {

    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', '10')
      .set('sortField', sortProperty || 'name')
      .set('sortDirection', sortDirection || 'asc')
      .set('name', name || '')
    return this.http.get(`${this.baseUrl}/v1/highways`, { params })
  }

  getHighwayContract(
    pageIndex: number,
    contractId: any,
    sortDirection?: string,
    sortProperty?: string,
    nomeRodovia?: string,
    nomeMunicio?: string,
    // nomeMunicipio?: string,

  ) {

    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('cityDescription', nomeMunicio || '')
      .set('highwayName', nomeRodovia || '')
    return this.http.get(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered`, { params })
  }
  getHistoryRodovias(contractId: string | null, highwayId: string | null, pageIndex:number = 0){
    return this.http.get(this.baseUrl + `/v1/contracts/${contractId}/highways-covered/${highwayId}/history?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
  addHighway(formdata: any, contractId: any) {
    return this.http.post(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered `, { ...formdata })
  }
  editHighway(formdata: any, contractId: any, highWayId: any) {
    return this.http.put(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered/${highWayId} `, { ...formdata })
  }
  deleteHighway(contractId: any, highWayId: any) {
    return this.http.delete(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered/${highWayId}`,)
  }
  validateImportHighway(contractId: any, data:any) {
    const formData = new FormData();
    formData.append('objetoOriginal', data?.file);
    return this.http.post(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered/validate-import`, formData)
  }
  importHighway(contractId: any, data:any, file:any, cpnj: any) {
    const formData = new FormData();
    const registrosValidosBlob = new Blob(
      [JSON.stringify(data?.registrosValidos)],
      { type: 'application/json' }
    );
    formData.append('registrosValidos', registrosValidosBlob);
    formData.append('nomeArquivo', file?.name);
    const fileExtension = file.type.split('/')[1];
    formData.append('tipoMime', fileExtension);
    formData.append('categoria', 'cadastro_contrato');
    formData.append('subCategoria', cpnj);
    formData.append('objetoOriginal', file?.file);
    return this.http.post(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered/import`, formData)
  }
}
